/**
 * Created by Bart Decorte
 * Date: 2019-07-17
 * Time: 10:48
 */
import BooleanColumn from "../columns/BooleanColumn";
import ColorColumn from "../columns/ColorColumn";
import CoordinatesColumn from "../columns/CoordinatesColumn";
import DateColumn from "../columns/DateColumn";
import DateTimeColumn from "../columns/DateTimeColumn";
import DropdownColumn from "../columns/DropdownColumn";
import EnumerationColumn from "../columns/EnumerationColumn";
import FileColumn from "../columns/FileColumn";
import IdColumn from "../columns/IdColumn";
import ImageColumn from "../columns/ImageColumn";
import MatrixColumn from "../columns/MatrixColumn";
import PasswordColumn from "../columns/PasswordColumn";
import RelationColumn from "../columns/RelationColumn";
import RichTextColumn from "../columns/RichTextColumn";
import SlugColumn from "../columns/SlugColumn";
import SortColumn from "../columns/SortColumn";
import StringColumn from "../columns/StringColumn";
import TextColumn from "../columns/TextColumn";
import TimeColumn from "../columns/TimeColumn";
import TimestampColumn from "../columns/TimestampColumn";
import TypeColumn from "../columns/TypeColumn";
import UrlColumn from "../columns/UrlColumn";
import MultiDropdownColumn from "../columns/MultiDropdownColumn";

function availableColumnTypes() {
  return { BooleanColumn, ColorColumn, CoordinatesColumn, DateColumn, DateTimeColumn, DropdownColumn, EnumerationColumn,
    FileColumn, IdColumn, ImageColumn, PasswordColumn, RelationColumn, RichTextColumn, SlugColumn, SortColumn,
    StringColumn, TextColumn, TimeColumn, TimestampColumn, TypeColumn, UrlColumn, MatrixColumn, MultiDropdownColumn
  };
}

function columnByType(type) {
  if (typeof type !== "string") {
    type = type.toString();
  }
  type = type.toLowerCase();
  // Adjust for different way of writing in the database
  type = (type === 'richtext') ? 'rich_text' : type;
  let pieces = type.split('_');
  pieces = pieces.map(piece => piece.substr(0, 1).toUpperCase() + piece.substr(1));
  const className = pieces.join('') + 'Column';

  if (Object.keys(availableColumnTypes()).indexOf(className) > -1) {
    return availableColumnTypes()[className];
  }

  return undefined;
}

export {
  availableColumnTypes,
  columnByType
}



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/column_helper.js